<template>
    <router-view v-slot="{ Component }">
      <component :is="Component">
        <template #progress>
        <vue-progress-bar />
        </template>
      </component>
    </router-view>
</template>

<script>
import axios from 'axios';
import { useOrganizationStore } from '@/stores/organization';
import { useSessionsStore } from '@/stores/sessions';
import { useCoursesStore } from '@/stores/courses';

export default {
  name: 'App',
  components: {},
  computed: {
    organization() {
      return useOrganizationStore().organization;
    },
    currentSession() {
      return useSessionsStore().currentSession;
    },
    course() {
      return useCoursesStore().course;
    },
  },
  watch: {
    $route(to) {
      const sessionName = this.currentSession ? this.currentSession.name : '';
      const courseName = this.course ? (`${sessionName} - ${this.course.name}`) : sessionName;
      const page = to.meta && to.meta.title ? to.meta.title : (courseName);
      const org = this.organization && this.organization.name ? this.organization.name : 'VTS Perform';
      document.title = `${org} - ${page}`;
    },
  },
  created() {
    axios.interceptors.request.use((config) => {
      this.$Progress.set(this.$Progress.get() + 0.0001);
      this.$Progress.increase(5);
      return config;
    },
    (error) => {
      this.$Progress.fail();
      Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      this.$Progress.increase(5);
      return response;
    },
    (error) => {
      this.$Progress.fail();

      return Promise.reject(error);
    });

    // //  [App.vue specific] When App.vue is first loaded start the progress bar
    // //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    // // //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
      //  finish the progress bar
      this.$Progress.finish();
    });
  },
};
</script>
